import DashletContainer from './DashletContainer';

export default DashletContainer;
